import { appHomeBreadcrumb, getRouteBySegment, portalApps } from '../../routes/routeConfig';
import type { BreadcrumbItem, NavItem, PortalAppDefinition } from '../types';

type NavigationConstants = {
  homeTitle: string;
  apps: PortalAppDefinition[];
  appHomeBreadcrumb: BreadcrumbItem;
};

export const navigationConstants: NavigationConstants = {
  homeTitle: 'Client Matter Administration Portal',
  apps: portalApps,
  appHomeBreadcrumb: appHomeBreadcrumb,
};

export const getPortalAppDefinition = (segment: string): PortalAppDefinition | undefined => {
  const route = getRouteBySegment(segment);
  if (!route?.isPortalApp) return undefined;

  const navItems: NavItem[] | undefined = Array.isArray(route.navItems)
    ? (route.navItems as readonly NavItem[]).map((navItem): NavItem => ({ ...navItem }))
    : undefined;

  return {
    id: route.segment,
    label: route.label,
    title: route.label,
    path: route.path,
    icon: route.icon,
    navItems,
  };
};
